import { render, staticRenderFns } from "./ActivityCard.vue?vue&type=template&id=18e6d544&scoped=true&lang=html&"
import script from "./ActivityCard.vue?vue&type=script&lang=js&"
export * from "./ActivityCard.vue?vue&type=script&lang=js&"
import style0 from "./ActivityCard.vue?vue&type=style&index=0&id=18e6d544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e6d544",
  null
  
)

export default component.exports